<footer id="mbfs-footer">
    <div id="mbfs-footer-nav-container">
<!--US Footer-->
<button class="scrollbutton" *ngIf="isShow" (click)="gotoTop()">
    <img src="/static/assets/img/dtf-assets/images/redesign/DTF_Scroll-to-Top_Icon_Wht.png">
</button>
<div *ngIf="!displayDefault && !guestPay">
    <nav *ngIf="!isCanadaPortal" id="mbfs-footer-navigation">
        <div class="mbfs-footer-nav-links-wrapper" *ngIf="!this.registration">
            <div class="mbfs-footer-nav-links">
                <div class="mbfs-footer-nav-links-lists">
                    <ul class="mbfs-footer-nav-links-list"
                    [attr.aria-expanded]="this.innerWidth < 768 ? 'false' : 'true'">
                    <li class="mbfs-footer-nav-links-header"><button type="link"
                        (click)="onClickLinkHeader($event)" [attr.tabindex]="this.innerWidth < 768 ? '0' : '-1'">
                            <span>{{ 'Footer.QuickLinks' | translate }}</span>
                        </button></li>
                    <li><a class="mbfs-footer-nav-items"  aria-label="Opens About Us" href="{{this.localRedirect}}/home/aboutus" >{{ 'Footer.AboutUs' | translate }}</a></li>
                    <li><a class="mbfs-footer-nav-items" aria-label="Opens Contact Us"  href="{{this.localRedirect}}/home/contactus" >{{ 'Footer.ContactUs' | translate }}</a></li>
                    <li><a class="mbfs-footer-nav-items" aria-label="Opens Press Releases" target="_blank" href="https://northamerica.daimlertruck.com/news-stories" >{{ 'Footer.PressReleases' | translate }}</a></li>
                    <li><a class="mbfs-footer-nav-items" aria-label="Opens Dealer Locator" href="{{this.localRedirect}}/home/dealerlocator" >{{ 'Footer.DealerLocator' | translate }}</a></li>
                    <li><a class="mbfs-footer-nav-items"  aria-label="Opens Calculator" href="{{this.localRedirect}}/home/calculator" >{{ 'Footer.Loan&PaymentCalculators' | translate }}</a></li>
                    <li><a  class="mbfs-footer-nav-items" aria-label="Opens Payment Options" href="{{this.localRedirect}}/home/paymentoptions" >{{ 'Footer.PaymentOptions' | translate }}</a></li>
                    <li><a class="mbfs-footer-nav-items" aria-label="Opens Careers" target="_blank" href="https://www.daimlertruck.com/career/job-search/" >{{ 'Footer.Careers' | translate }}</a></li>
                    <li><a class="mbfs-footer-nav-items" target="_blank" aria-label="Opens Agency Recruiters" href="https://recruitifi.com/app/public/agency-registration?solicited_employer=eb15eef3-98d8-4ff3-b9db-eef960f032ac" >{{ 'Footer.AgencyRecruiters' | translate }}</a></li>
                    <li><a class="mbfs-footer-nav-items" target="_blank" aria-label="Opens Agency Recruiters" href="{{ this.repayURL }}" >{{ 'Footer.Repay' | translate }}</a></li>
                </ul>
                <ul class="mbfs-footer-nav-links-list"
                    [attr.aria-expanded]="this.innerWidth < 768 ? 'false' : 'true'">
                    <li class="mbfs-footer-nav-links-header"><button type="link"
                        (click)="onClickLinkHeader($event)" [attr.tabindex]="this.innerWidth < 768 ? '0' : '-1'">
                            <span>{{ 'Footer.FinanceTools' | translate }}</span>
                        </button></li>
                        <li><a class="mbfs-footer-nav-items" aria-label="Opens Finance Lease" href="{{this.localRedirect}}/home/financeleasesolutions" > {{ 'Header.FinanceSolutions' | translate }}</a></li>
                        <li><a class="mbfs-footer-nav-items" aria-label="Opens Finance Lease" href="{{this.localRedirect}}/home/connected-insurance" > {{ 'Header.ConnectedInsurance' | translate }}</a></li>
                        <li><a class="mbfs-footer-nav-items"  href="{{this.localRedirect}}/home/insurance" >{{ 'Footer.Insurance' | translate }}</a></li>
                        <li><a class="mbfs-footer-nav-items" target="_blank" aria-label="Opens Dynamic Lease" href="{{this.localRedirect}}/home/dynamicfinancing"> {{ 'Header.DynamicProducts' | translate }}</a></li>
                        <li><a class="mbfs-footer-nav-items" aria-label="Opens EV Solutions" href="{{this.localRedirect}}/home/electricFMV"> {{ 'Header.EVSolutions' | translate }}</a></li>
                        <li><a class="mbfs-footer-nav-items"  aria-label="Opens Brochures" href="{{this.localRedirect}}/home/brochures"> {{ 'Header.Brochures' | translate }}</a></li>
                        <!-- <li><a class="mbfs-footer-nav-items"  aria-label="Opens Special Programs" href="{{this.localRedirect}}/home/programs" >{{ 'Footer.SpecialPrograms' | translate }}</a></li> -->
                </ul>
                <ul class="mbfs-footer-nav-links-list"
                    [attr.aria-expanded]="this.innerWidth < 768 ? 'false' : 'true'">
                    <li class="mbfs-footer-nav-links-header"><button type="link"
                        (click)="onClickLinkHeader($event)" [attr.tabindex]="this.innerWidth < 768 ? '0' : '-1'">
                            <span>{{ 'Footer.Support' | translate }}</span>
                        </button></li>
                        <li><a class="mbfs-footer-nav-items" aria-label="Opens FAQ" href="{{this.localRedirect}}/home/faq" >{{ 'Footer.FrequentlyAskedQuestions' | translate }}</a></li>
                        <li><a class="mbfs-footer-nav-items" aria-label="Opens Glossary" href="{{this.localRedirect}}/home/glossary" >{{ 'Footer.Glossary' | translate }}</a></li>
                        <li><a class="mbfs-footer-nav-items" aria-label="Opens CCPA" href="{{this.localRedirect}}/home/useAndPrivacy" >{{ 'Footer.CCPA' | translate }}</a></li>
                </ul>
                </div>
            </div>
            <div class="mbfs-footer-nav-links">
                <div class="mbfs-footer-nav-links-header">
                    <button type="link" (click)="onClickOtherSitesLinkHeader($event)">
                        <span>{{ 'Footer.OurBrands' | translate }}</span>
                    </button>
                </div>
            </div>
            <div id="mbfs-footer-nav-other-sites-links" class="mbfs-footer-nav-links">
                <div class="mbfs-footer-nav-links-lists"
                [attr.aria-expanded]="this.innerWidth < 768 ? 'false' : 'true'">
                <ul class="mbfs-footer-nav-links-list">
                    <li><a target="_blank" href="https://freightliner.com/">
                        <img src="static/assets/img/dtf-assets/images/redesign/Freightliner Logo_Transparent.png" alt="FreightLiner Logo"/>
                    </a></li>
                </ul>
                <ul class="mbfs-footer-nav-links-list">
                    <li><a target="_blank" href="https://www.westernstartrucks.com/dealers/"  >
                    <img src="static/assets/img/dtf-assets/images/redesign/thumbnail_Western Star Logo_Transparent.png" alt="WesternStar Logo"/>
                    </a></li>
                </ul>
                <ul class="mbfs-footer-nav-links-list">
                    <li><a target="_blank" href="https://thomasbuiltbuses.com/" >
                    <img src="static/assets/img/dtf-assets/images/redesign/thomas_logo_footer.png" alt="ThomasTruck Logo"/>
                    </a></li>
                </ul>
                <ul class="mbfs-footer-nav-links-list">
                    <li><a target="_blank" href="https://selectrucks.com/" >
                    <img src="static/assets/img/dtf-assets/images/redesign/selectrucks-logo-black-red.svg" alt="Selectrucks Logo"/>
                    </a></li>
                </ul>
                <ul class="mbfs-footer-nav-links-list">
                <li><a target="_blank" href="https://www.mercedes-benz-bus.com/" >
                    <img src="static/assets/img/dtf-assets/images/redesign/Mercedes-Benz_Logo_Final.png" alt="MBBus Logo"/>
                </a></li>
                </ul>
                <ul class="mbfs-footer-nav-links-list">
                <li><a target="_blank" href="https://www.fccccommercial.com/find-a-dealer/" >
                    <img src="static/assets/img/dtf-assets/images/redesign/fccclogo2.png" alt="FCCC Logo"/>
                </a></li>
                </ul>
            </div>
            </div>
        </div>
    </nav>

    <!--Canada Footer-->
    <nav *ngIf="isCanadaPortal" id="mbfs-footer-navigation">
    <div class="mbfs-footer-nav-links-wrapper" *ngIf="!this.registration">
        <div class="mbfs-footer-nav-links">
            <div class="mbfs-footer-nav-links-lists">
                <ul class="mbfs-footer-nav-links-list"
                [attr.aria-expanded]="this.innerWidth < 768 ? 'false' : 'true'">
                <li class="mbfs-footer-nav-links-header"><button type="link"
                    (click)="onClickLinkHeader($event)" [attr.tabindex]="this.innerWidth < 768 ? '0' : '-1'">
                        <span>{{ 'Footer.QuickLinks' | translate }}</span>
                    </button></li>
                <li><a class="mbfs-footer-nav-items" aria-label="Opens About Us"  href="{{this.localRedirect}}home/aboutus" >{{ 'Footer.AboutUs' | translate }}</a></li>
                <li><a class="mbfs-footer-nav-items"  aria-label="Opens Contact Us" href="{{this.localRedirect}}home/contactus" > {{ 'Footer.ContactUs' | translate }}</a></li>
                <li><a class="mbfs-footer-nav-items" aria-label="Opens Dealer Locator"  href="{{this.localRedirect}}home/dealerlocator" >{{ 'Footer.DealerLocator' | translate }}</a></li>
                <li><a class="mbfs-footer-nav-items" aria-label="Opens Calculator" href="{{this.localRedirect}}home/calculator" >{{ 'Footer.Loan&PaymentCalculators' | translate }}</a></li>
                <li><a class="mbfs-footer-nav-items" aria-label="Opens Payment Options" href="{{this.localRedirect}}home/paymentOption" >{{ 'Footer.PaymentOption' | translate }}</a></li>
                <li><a class="mbfs-footer-nav-items" target="_blank"aria-label="Opens Daimler Career" href="https://www.daimlertruck.com/career/job-search/" >{{ 'Footer.Careers' | translate }}</a></li>
            </ul>
            <ul class="mbfs-footer-nav-links-list"
                [attr.aria-expanded]="this.innerWidth < 768 ? 'false' : 'true'">
                <li class="mbfs-footer-nav-links-header"><button type="link"
                    (click)="onClickLinkHeader($event)" [attr.tabindex]="this.innerWidth < 768 ? '0' : '-1'">
                        <span>{{ 'Footer.FinanceTools' | translate }}</span>
                    </button></li>
                    <li><a class="mbfs-footer-nav-items"  aria-label="Opens Finance Solutions" href="{{this.localRedirect}}home/financeleasesolutions" > {{ 'Header.FinanceSolutions' | translate }}</a></li>
                    <li><a class="mbfs-footer-nav-items"  aria-label="Opens Insurance" href="{{this.localRedirect}}home/insurance" >{{ 'Footer.ProtectionProducts' | translate }}</a></li>
                    <li><a class="mbfs-footer-nav-items"  aria-label="Opens EV Solutions" href="{{this.localRedirect}}home/electricFMV" > {{ 'Header.EVSolutions' | translate }}</a></li>
                    <li><a class="mbfs-footer-nav-items"  aria-label="Opens Brochures" href="{{this.localRedirect}}home/brochures" > {{ 'Header.Brochures' | translate }}</a></li>
                    <!-- <li><a class="mbfs-footer-nav-items"  href="{{this.localRedirect}}home/programs" >{{ 'Header.SpecialPrograms' | translate }}</a></li> -->
            </ul>
            <ul class="mbfs-footer-nav-links-list"
                [attr.aria-expanded]="this.innerWidth < 768 ? 'false' : 'true'">
                <li class="mbfs-footer-nav-links-header"><button type="link"
                    (click)="onClickLinkHeader($event)" [attr.tabindex]="this.innerWidth < 768 ? '0' : '-1'">
                        <span>{{ 'Footer.Support' | translate }}</span>
                    </button></li>
                    <li><a class="mbfs-footer-nav-items"  aria-label="Opens FAQ" href="{{this.localRedirect}}home/faq" >{{ 'Footer.FrequentlyAskedQuestions' | translate }}</a></li>
                    <li><a class="mbfs-footer-nav-items"  aria-label="Opens Glossary" href="{{this.localRedirect}}home/glossary" >{{ 'Footer.Glossary' | translate }}</a></li>
            </ul>
            </div>
        </div>
        <div class="mbfs-footer-nav-links">
            <div class="mbfs-footer-nav-links-header">
                <button type="link" (click)="onClickOtherSitesLinkHeader($event)">
                    <span>{{ 'Footer.OurBrands' | translate }}</span>
                </button>
            </div>
        </div>
        <div id="mbfs-footer-nav-other-sites-links" class="mbfs-footer-nav-links">
            <div class="mbfs-footer-nav-links-lists"
            [attr.aria-expanded]="this.innerWidth < 768 ? 'false' : 'true'">
            <ul class="mbfs-footer-nav-links-list">
                <li><a target="_blank" href="https://freightliner.com/" >
                    <img src="static/assets/img/dtf-assets/images/redesign/Freightliner Logo_Transparent.png" alt="FreightLiner Logo"/>
                </a></li>
            </ul>
            <ul class="mbfs-footer-nav-links-list">
                <li><a target="_blank" href="https://www.westernstartrucks.com/dealers/" >
                    <img src="static/assets/img/dtf-assets/images/redesign/thumbnail_Western Star Logo_Transparent.png" alt="WesternStar Logo"/>
                </a></li>
            </ul>
            <ul class="mbfs-footer-nav-links-list">
                <li><a target="_blank" href="https://thomasbuiltbuses.com/" >
                    <img src="static/assets/img/dtf-assets/images/redesign/thomas_logo_footer.png" alt="ThomasTruck Logo"/>
                </a></li>
            </ul>
            <ul class="mbfs-footer-nav-links-list">
                <li><a target="_blank" href="https://www.fccccommercial.com/find-a-dealer/">
                        <img src="static/assets/img/dtf-assets/images/redesign/fccclogo2.png" alt="FCCC Logo" />
                    </a></li>
            </ul>
        </div>
        </div>
    </div>
    </nav>
</div>
<!--Copyright footer-->
<div role="contentinfo" *ngIf="!guestPay">
  <div class="mbfs-copyright">
      <p>&copy; {{ this.currentYear }} {{ 'Footer.FooterBrand' | translate }}
        <a *ngIf="!isCanadaPortal" style="color:#565656" href="https://nmlsconsumeraccess.org/" target="_blank">{{ 'Footer.NMLS' | translate }}</a>
      </p>
  </div>
  <ul class="mbfs-meta">
      <li>
          <a *ngIf="isCanadaPortal" aria-label="Opens Terms And Conditions" href="{{this.localRedirect}}home/useAndPrivacy" >{{ 'Footer.TermsandConditions' | translate }}</a>
          <a *ngIf="isCanadaPortal" aria-label="Opens Privacy Policy" href="{{this.localRedirect}}home/newPrivacy" >{{ 'Footer.PrivacyPolicy' | translate }}</a>
          <a *ngIf="!isCanadaPortal" aria-label="Opens Terms and Conditions" href="home/useAndPrivacy" >{{ 'Footer.TermsandConditions' | translate }}</a>
      </li>
      <!-- <li><a *ngIf="isCanadaPortal" href="home/useAndPrivacy" >{{ 'Footer.PrivacyPolicy' | translate }}</a></li> -->
      <!-- <li><a *ngIf="!isCanadaPortal"  href="{{this.targetRedirect}}en/footer/sitemap.do">{{ 'Footer.SiteMap' | translate }}</a></li> -->
      <li>
        <a *ngIf="isCanadaPortal" [href]="(language === 'fr-CA') ? 'static/assets/pdf/DTFS_AODA_Policy_Multi-year_plan_FR_CAN_20231220.pdf' : 'static/assets/pdf/DTFS_AODA Policy_Multi-year_plan_EN_CAN_20231220.pdf'" target="_blank">{{ 'Footer.AODA' | translate }}</a>
    </li>
  </ul>
</div>
</div>

<!-- <div *ngIf="guestPay">

    <div role="contentinfo" style="margin-left: 37%;">
        <div class="mbfs-copyright">
            <p >&copy; {{ this.currentYear }} {{ 'Footer.FooterBrand' | translate }}
              <a *ngIf="!isCanadaPortal" style="color:#565656" href="https://nmlsconsumeraccess.org/" target="_blank">{{ 'Footer.NMLS' | translate }}</a>
            </p>
        </div>
        <ul class="mbfs-meta">
            <li>
                <a *ngIf="isCanadaPortal" aria-label="Opens Terms And Conditions" href="{{this.localRedirect}}home/useAndPrivacy" >{{ 'Footer.TermsandConditions' | translate }}</a>
                <a *ngIf="isCanadaPortal" aria-label="Opens Privacy Policy" href="{{this.localRedirect}}home/newPrivacy" >{{ 'Footer.PrivacyPolicy' | translate }}</a>
                <a *ngIf="!isCanadaPortal" aria-label="Opens Terms and Conditions" href="home/useAndPrivacy" >{{ 'Footer.TermsandConditions' | translate }}</a>
            </li>
            <li><a *ngIf="isCanadaPortal" href="home/useAndPrivacy" >{{ 'Footer.PrivacyPolicy' | translate }}</a></li>
            <li><a *ngIf="!isCanadaPortal"  href="{{this.targetRedirect}}en/footer/sitemap.do">{{ 'Footer.SiteMap' | translate }}</a></li>
            <li>
              <a *ngIf="isCanadaPortal" [href]="(language === 'fr-CA') ? 'static/assets/pdf/DTFS_AODA_Policy_Multi-year_plan_FR_CAN_20231220.pdf' : 'static/assets/pdf/DTFS_AODA Policy_Multi-year_plan_EN_CAN_20231220.pdf'" target="_blank">{{ 'Footer.AODA' | translate }}</a>
          </li>
        </ul>
      </div>

</div> -->

</footer>